<div class="container-right-main fluid-container">
    <div class="display-flex">
        <div class="float-left">
            <h2>Requests</h2>
        </div>
        <div class="float-right">
            <button class="bttn" (click)="openCreateRequestDialog()">Submit Request</button>
        </div>
    </div>
    <mat-tab-group [(selectedIndex)]="selectedTab" (selectedIndexChange)="onTabChange($event)" class="request-tabs">
        <mat-tab>
            <ng-template mat-tab-label>
                <span class="tab-label">Bugs</span>
            </ng-template>
            <div class="display-flex filter-container">
                <div class="float-left">
                    <app-search-field [formControl]="searchFilter" placeholder="Search by subject or username..."
                        [showMatchCount]="true" [matchCount]="totalCount">
                    </app-search-field>
                </div>
                <div class="float-right">
                    <app-select [formControl]="statusFilter" [field]="{ label: 'Status', options: [
                       { label: 'All', value: '' },
                       { label: 'Not started', value: 'Not started' },
                       { label: 'In Progress', value: 'In Progress' },
                       { label: 'Closed', value: 'Closed' }
                     ] }">
                    </app-select>
                </div>
            </div>

            <app-grid [data]="filteredRequestList" [columns]="requestColumns" [config]="gridConfig"
                (rowClick)="onRowClick($event)">
            </app-grid>
            <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPage"
                [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" showFirstLastButtons>
            </mat-paginator>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <span class="tab-label">Enhancement</span>
            </ng-template>
            <div class="display-flex filter-container">
                <div class="float-left">
                    <app-search-field [formControl]="searchFilter" placeholder="Search by subject or username..."
                        [showMatchCount]="true" [matchCount]="totalCount">
                    </app-search-field>
                </div>
                <div class="float-right">
                    <app-select [formControl]="statusFilter" [field]="{ label: 'Status', options: [
                       { label: 'All', value: '' },
                       { label: 'Not started', value: 'Not started' },
                       { label: 'In Progress', value: 'In Progress' },
                       { label: 'Closed', value: 'Closed' }
                        ] }">
                    </app-select>
                </div>
            </div>

            <app-grid [data]="filteredRequestList" [columns]="requestColumns" [config]="gridConfig"
                (rowClick)="onRowClick($event)">
            </app-grid>
            <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPage"
                [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" showFirstLastButtons>
            </mat-paginator>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <span class="tab-label">General Questions</span>
            </ng-template>
            <div class="display-flex filter-container">
                <div class="float-left">
                    <app-search-field [formControl]="searchFilter" placeholder="Search by subject or username..."
                        [showMatchCount]="true" [matchCount]="totalCount">
                    </app-search-field>
                </div>
                <div class="float-right">
                    <app-select [formControl]="statusFilter" [field]="{ label: 'Status', options: [
                       { label: 'All', value: '' },
                       { label: 'Not started', value: 'Not started' },
                       { label: 'In Progress', value: 'In Progress' },
                       { label: 'Closed', value: 'Closed' }
                        ] }">
                    </app-select>
                </div>
            </div>

            <app-grid [data]="filteredRequestList" [columns]="generalQuestionsColumns"
                [config]="generalQuestionsGridConfig">
            </app-grid>
            <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPage"
                [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" showFirstLastButtons>
            </mat-paginator>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <span class="tab-label">Assigned Request</span>
            </ng-template>
            <div class="display-flex filter-container">
                <div class="float-left">
                    <app-search-field [formControl]="searchFilter" placeholder="Search by subject or username..."
                        [showMatchCount]="true" [matchCount]="totalCount">
                    </app-search-field>
                </div>
            </div>

            <app-grid [data]="filteredRequestList" [columns]="requestColumns" [config]="gridConfig"
                (rowClick)="onRowClick($event)">
            </app-grid>
            <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPage"
                [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" showFirstLastButtons>
            </mat-paginator>
        </mat-tab>


    </mat-tab-group>
</div>